import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import InstagramIcon from '@material-ui/icons/Instagram';

const InstagramButton = () => {
    return (
        <IconButton color="inherit" target="_blank" href="https://www.instagram.com/komugiya_yaizu/">
            <InstagramIcon />
        </IconButton>
    )
}

export default InstagramButton;